import { render, staticRenderFns } from "./NewQuote.vue?vue&type=template&id=9610f774&"
import script from "./NewQuote.vue?vue&type=script&lang=js&"
export * from "./NewQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports